<template>
  <v-container id="profile-edit-page">
    <v-card class="pa-10 mb-8">
      <div class="_fs-36">
        แก้ไขข้อมูลส่วนตัว
      </div>
      <div>จัดการข้อมูลส่วนตัวคุณของบัญชีผู้ใช้นี้</div>

      <v-divider class="my-4"></v-divider>

      <v-row>
        <v-col
          cols="6"
          md="2"
          class="d-flex align-center justify-center">
          <v-avatar size="100">
            <v-img :src="userProfile.pictureUrl"></v-img>
          </v-avatar>
        </v-col>

        <v-col
          cols="6"
          md="10"
          class="d-flex flex-column justify-center">
          <div>
            <span class="font-weight-bold">Display Name:</span>
            <br class="d-md-none" />
            <span class="primary--text">
              {{ userProfile.displayName }}
            </span>
          </div>
          <div>
            <span class="font-weight-bold">Basic ID:</span>
            <br class="d-md-none" />
            <span class="primary--text">
              {{ activeBasicId }}
            </span>
          </div>
        </v-col>
      </v-row>

      <validation-observer ref="editProfileForm">
        <v-row class="mt-4">
          <v-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              ref="displayName"
              rules="required"
              name="Display Name"
            >
              <base-text-field
                v-model="submitForm.displayName"
                label="Display Name"
                type="text"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
            <div class="error--text _fs-14">
              <div>*** หมายเหตุ Display Name สามารถตั้งได้ไม่เกิน 20 ตัวอักษร</div>
            </div>
          </v-col>

          <v-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              ref="companyName"
              rules="required"
              name="ชื่อร้านค้า หรือชื่อบริษัท"
            >
              <base-text-field
                v-model="submitForm.companyName"
                label="ชื่อร้านค้า หรือบริษัท"
                type="text"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col cols="12">
            <p class="_fs-20">
              ประเภทของผู้เสียภาษี
            </p>
            <v-radio-group
              :value="isJuristicCustomer"
              @change="onUpdateCustomerType">
              <v-radio
                :value="false"
                label="บุคคลธรรมดา">
              </v-radio>
              <v-radio
                :value="true"
                label="นิติบุคคล">
              </v-radio>
            </v-radio-group>
          </v-col>

          <template v-if="isJuristicCustomer">
            <v-col cols="12">
              <v-select
                v-model="submitForm.customerTypeId"
                label="ประเภทของนิติบุคคล"
                filled
                rounded
                hide-details
                :items="sortJuristicCustomerTypes"
              >
              </v-select>
            </v-col>

            <v-col cols="12">
              <v-radio-group
                :value="isHeadquarter"
                @change="onUpdateIsHeadquarter">
                <v-radio
                  :value="true"
                  label="สำนักงานใหญ่">
                </v-radio>
                <v-radio
                  :value="false"
                  label="สาขาย่อย">
                </v-radio>
              </v-radio-group>

              <validation-provider
                v-slot="{ errors }"
                ref="branchNumber"
                rules="required|length:5|integer"
                name="เลขที่สาขา"
              >
                <base-text-field
                  v-model="submitForm.branchNumber"
                  :disabled="isHeadquarter"
                  label="เลขที่สาขา"
                  type="tel"
                  maxlength="5"
                  :error-messages="errors"
                >
                </base-text-field>
              </validation-provider>
            </v-col>
          </template>

          <v-col
            v-if="isJuristicCustomer"
            cols="12">
            <validation-provider
              v-slot="{ errors }"
              ref="citizenId"
              :rules="{ required: true, citizenId: { isJuristicCustomer } }"
              :name="$utils.citizenIdText(isJuristicCustomer)"
            >
              <base-text-field
                v-model="submitForm.citizenId"
                :label="$utils.citizenIdText(isJuristicCustomer)"
                type="tel"
                maxlength="13"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="firstName"
              rules="required"
              name="ชื่อ">
              <base-text-field
                v-model="submitForm.firstName"
                label="ชื่อ"
                type="text"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="lastName"
              rules="required"
              name="นามสกุล">
              <base-text-field
                v-model="submitForm.lastName"
                label="นามสกุล"
                type="text"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="pt-md-11">
            <validation-provider
              v-slot="{ errors }"
              ref="email"
              rules="required|email"
              name="Email สำหรับส่งใบกำกับภาษี (E-Tax Online)">
              <base-text-field
                v-model="submitForm.email"
                label="Email สำหรับส่งใบกำกับภาษี (E-Tax Online)"
                type="email"
                :error-messages="errors">
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <v-checkbox
              v-model="useSameEmail"
              label="Email เดียวกับที่ส่งใบกำกับภาษี"
              hide-details
              style="margin: 0px; padding: 4px 20px;"
              @change="onUseSameEmail"
            />
            <validation-provider
              v-slot="{ errors }"
              ref="emailQuotation"
              rules="required|email"
              name="Email สำหรับส่งใบเสนอราคา">
              <base-text-field
                v-model="submitForm.emailQuotation"
                label="Email สำหรับส่งใบเสนอราคา"
                type="email"
                :error-messages="errors">
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="tel"
              rules="required|integer"
              name="เบอร์โทรศัพท์"
            >
              <base-text-field
                v-model="submitForm.tel"
                label="เบอร์โทรศัพท์"
                type="tel"
                maxlength="10"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>
        </v-row>

        <div class="_fs-20">
          ที่อยู่ของร้านค้า หรือบริษัท
        </div>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              ref="address"
              rules="required"
              name="ที่อยู่">
              <base-text-field
                v-model="submitForm.address"
                label="ที่อยู่ (ระบุเลขที่ อาคาร ชั้นที่ ห้องที่ หมู่ หรือซอย)"
                type="text"
                :error-messages="errors"
              >
              </base-text-field>
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <base-text-field
              v-model="submitForm.street"
              label="ถนน"
              type="text"
              is-optional>
            </base-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="subdistrict"
              rules="required"
              name="แขวง/ตำบล"
            >
              <base-thai-address-autocomplete
                v-model="submitForm.subdistrict"
                address-type="subdistrict"
                label="แขวง/ตำบล"
                type="text"
                :error-messages="errors"
                @select="onSelectAddress"
              />
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="district"
              rules="required"
              name="เขต/อำเภอ"
            >
              <base-thai-address-autocomplete
                v-model="submitForm.district"
                address-type="district"
                label="เขต/อำเภอ"
                :error-messages="errors"
                type="text"
                @select="onSelectAddress"
              />
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="stateProvince"
              rules="required"
              name="จังหวัด"
            >
              <base-thai-address-autocomplete
                v-model="submitForm.stateProvince"
                address-type="stateProvince"
                label="จังหวัด"
                :error-messages="errors"
                type="text"
                @select="onSelectAddress"
              />
            </validation-provider>
          </v-col>

          <v-col
            cols="12"
            md="6">
            <validation-provider
              v-slot="{ errors }"
              ref="zipCode"
              rules="required|length:5|integer"
              name="รหัสไปรษณีย์"
            >
              <base-thai-address-autocomplete
                v-model="submitForm.zipCode"
                address-type="zipCode"
                label="รหัสไปรษณีย์"
                :error-messages="errors"
                type="tel"
                maxlength="5"
                @select="onSelectAddress"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </validation-observer>

      <div class="d-flex flex-column flex-md-row justify-center">
        <v-btn
          rounded
          color="primary"
          min-width="150"
          outlined
          exact
          :to="{ name: 'Home' }">
          ยกเลิก
        </v-btn>
        <v-btn
          class="mt-4 mt-md-0 ml-md-4"
          rounded
          color="primary"
          min-width="150"
          @click="submit">
          บันทึก
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import BaseTextField from '@/components/BaseTextField.vue'
import BaseThaiAddressAutocomplete from '@/components/BaseThaiAddressAutocomplete.vue'

export default {
  name: 'ProfileEditPage',
  components: {
    BaseTextField,
    BaseThaiAddressAutocomplete
  },
  data() {
    return {
      useSameEmail: false,
      customerType: 'normal',
      packageStartedMenu: false,
      packageStartedAt: '',
      submitForm: {
        firstName: undefined,
        lastName: undefined,
        displayName: undefined,
        companyName: undefined,
        branchNumber: this.$default.HEADQUARTER_BRANCH_NUMBER,
        customerTypeId: this.$default.NORMAL_CUSTOMER_TYPE_VALUE,
        citizenId: undefined,
        address: undefined,
        street: undefined,
        subdistrict: undefined,
        district: undefined,
        stateProvince: undefined,
        zipCode: undefined,
        email: undefined,
        emailQuotation: undefined,
        tel: undefined
      },
      cloneSubmitForm: {}
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      activeBasicId: 'User/activeBasicId',
      activeLineOfficialAccount: 'User/activeLineOfficialAccount',
      filterJuristicCustomerTypes: 'CustomerType/filterJuristicCustomerTypes'
    }),
    isJuristicCustomer() {
      return this.$utils.isJuristicCustomer(this.submitForm.customerTypeId)
    },
    isHeadquarter() {
      return this.$utils.isHeadquarter(this.submitForm.branchNumber)
    },
    sortJuristicCustomerTypes() {
      const juristicCustomerTypes = this.filterJuristicCustomerTypes
      return juristicCustomerTypes.sort((a, b) => {
        if (a.index < b.index) return -1
        if (a.index > b.index) return 1
        return 0
      })
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'submitForm.email': function(value) {
      if (this.useSameEmail) {
        this.$set(this.submitForm, 'emailQuotation', value)
      }
    }
  },
  created() {
    this.submitForm = {
      ...this.activeLineOfficialAccount,
      peakContactId: undefined
    }
    this.cloneSubmitForm = JSON.parse(JSON.stringify(this.submitForm))
  },
  methods: {
    ...mapActions({
      fetchProfile: 'User/fetchProfile',
      updateLineOfficialAccount: 'LineOfficialAccount/updateLineOfficialAccount'
    }),
    ...mapWaitingActions('LineOfficialAccount', {
      updateLineOfficialAccount: 'app loading'
    }),
    ...mapWaitingActions('User', {
      fetchProfile: 'app loading'
    }),
    onUseSameEmail() {
      if (this.useSameEmail) {
        this.$set(this.submitForm, 'emailQuotation', this.submitForm.email)
      } else {
        this.$set(this.submitForm, 'emailQuotation', undefined)
      }
    },
    onUpdateCustomerType(value) {
      const customerTypeValue = value
        ? this.$default.JURISTIC_CUSTOMER_TYPE_VALUE
        : this.$default.NORMAL_CUSTOMER_TYPE_VALUE
      this.$set(this.submitForm, 'customerTypeId', customerTypeValue)
    },
    onUpdateIsHeadquarter(value) {
      const newBranchNumber = value ? this.$default.HEADQUARTER_BRANCH_NUMBER : ''
      this.$set(this.submitForm, 'branchNumber', newBranchNumber)
    },
    onSelectAddress(value) {
      this.$set(this.submitForm, 'subdistrict', value.subdistrict)
      this.$set(this.submitForm, 'district', value.district)
      this.$set(this.submitForm, 'stateProvince', value.stateProvince)
      this.$set(this.submitForm, 'zipCode', value.zipCode)
    },
    async submit() {
      const canSubmit = await this.$refs.editProfileForm.validate()
      if (!canSubmit) {
        this.$utils.scrollToErrorField('editProfileForm', this)
        return
      }

      await this.updateLineOfficialAccount(this.submitForm)
      await this.fetchProfile()
      await this.$swal({
        title: 'สำเร็จแล้ว',
        text: 'คุณได้แก้ไขข้อมูลส่วนตัวเรียบร้อยแล้ว',
        icon: 'success'
      })

      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
